module.exports = __webpack_public_path__ + "files/bdaa3af5fac5daaf6c7937297d4093b1.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/PT-Sans-regular.ttf
 ** module id = 865
 ** module chunks = 0
 **/